"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.areIncludedUnitsInBaseMerchSelector = exports.getCalculateBundlePriceSelector = exports.getMultiplePriceBreakdownsSelector = exports.getCalculatePriceAndItemConfigSelector = exports.getCalculateDiscountedOnboardingPriceSelector = exports.getAdditionalSeatMonthlyCostSelector = exports.getAdditionalContactsCostSelector = exports.getAdditionalContactsMonthlyCostSelector = exports.contactTierPriceMapSelector = exports.calculatedPriceSelector = exports.createPurchaseConfigSelector = exports.getTermIdSelector = exports.getEligibleTermIdsSelector = exports.getDiscountPercentageSelector = exports.productDataSelector = void 0;

var _Raven = _interopRequireDefault(require("Raven"));

var _calculatedPriceAdapter = _interopRequireDefault(require("self-service-api/adapters/calculatedPriceAdapter"));

var _MerchandiseSelectors = require("pricing-pages-unified-ui/selectors/MerchandiseSelectors");

var _CurrentSubscriptionsSelectors = require("pricing-pages-unified-ui/selectors/CurrentSubscriptionsSelectors");

var _contactTierPriceMapAdapter = _interopRequireDefault(require("self-service-api/adapters/contactTierPriceMapAdapter"));

var _CurrencySelectors = require("pricing-pages-unified-ui/selectors/CurrencySelectors");

var _reselect = require("reselect");

var _PromotionSelectors = require("./PromotionSelectors");

var _RequiredOnboardingSelectors = require("./RequiredOnboardingSelectors");

var _TermIds = require("self-service-api/constants/TermIds");

var _Terms = require("self-service-api/constants/Terms");

var _ChargeTypes = require("self-service-api/constants/ChargeTypes");

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var _itemConfigUtils = require("../utils/itemConfigUtils");

var _ItemConfigsSelectors = require("./ItemConfigsSelectors");

var _pricingUtils = require("../utils/pricingUtils");

var _MarketingContactsSelectors = require("./MarketingContactsSelectors");

var _ContactsSelectors = require("./ContactsSelectors");

var productDataSelector = (0, _reselect.createSelector)(_MerchandiseSelectors.merchandiseSelector, function (merchandise) {
  return {
    products: merchandise
  };
});
exports.productDataSelector = productDataSelector;

var getDiscountPercentageSelector = function getDiscountPercentageSelector(state) {
  return function (merchandiseId, termIdToUse) {
    var eligiblePromotions = (0, _PromotionSelectors.allPromotionsSelector)(state);
    var promotionInfo = eligiblePromotions.merchEligibleForDirectPromotions && eligiblePromotions.merchEligibleForDirectPromotions[merchandiseId];

    if (promotionInfo && termIdToUse === promotionInfo.annualOfferId) {
      return promotionInfo.annualDiscount;
    }

    if (promotionInfo && termIdToUse === promotionInfo.monthlyOfferId) {
      return promotionInfo.monthlyDiscount;
    }

    return null;
  };
};

exports.getDiscountPercentageSelector = getDiscountPercentageSelector;

var getEligibleTermIdsSelector = function getEligibleTermIdsSelector(state) {
  return function (merchandiseId) {
    var eligiblePromotions = (0, _PromotionSelectors.allPromotionsSelector)(state);
    var productEligiblePromotion = eligiblePromotions.merchEligibleForDirectPromotions && eligiblePromotions.merchEligibleForDirectPromotions[merchandiseId];

    if (productEligiblePromotion) {
      return {
        annual: productEligiblePromotion.annualOfferId,
        monthly: productEligiblePromotion.monthlyOfferId
      };
    } // to keep a watch on merch not covered by the BE
    // will default to no discount for now


    _Raven.default.captureMessage('Merchandise id not covered by EE promotions', {
      extra: {
        merchandiseId: merchandiseId
      }
    });

    return {
      annual: _TermIds.ANNUAL_NO_DISCOUNT,
      monthly: _TermIds.MONTHLY_NO_DISCOUNT
    };
  };
};

exports.getEligibleTermIdsSelector = getEligibleTermIdsSelector;

var getTermIdSelector = function getTermIdSelector(state) {
  return function (merchandiseId, term) {
    var isGrowthSuite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isCovidPromo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var merchandiseMap = (0, _MerchandiseSelectors.merchandiseSelector)(state);

    if (!merchandiseMap[merchandiseId]) {
      throw new Error("Cannot get TermID for unknown merchandise ID \"" + merchandiseId + "\"");
    }

    var isRecurringMerch = merchandiseMap[merchandiseId].chargeType === _ChargeTypes.RECURRING;
    var isSalesOrServiceProfessionalOnboarding = merchandiseId === _MerchandiseIds.SERVICE_SALES_PROFESSIONAL_ONBOARDING_NOV_2019 || merchandiseId === _MerchandiseIds.SERVICE_SERVICE_PROFESSIONAL_ONBOARDING_NOV_2019; // 11/1 hacky logic for sales and service professional onboarding promotion:
    // Because we have to directly calculate the 50% promotion price to display
    // on the pricing page, when we see either merch id here we immediately return
    // the default term id so it does not interfere with the term id logic below

    if (isSalesOrServiceProfessionalOnboarding) {
      return _TermIds.MONTHLY_NO_DISCOUNT;
    }

    if (isGrowthSuite) {
      var edition = merchandiseMap[merchandiseId].edition || 'noEdition';
      var availableTerms = (0, _PromotionSelectors.growthSuiteAvailableTermsSelector)(state, isCovidPromo)[edition]; // Attempt to apply desired term, but fallback to whatever is available
      // For cases where the product doesn't support the desired term, like Marketing Ent on monthly terms

      var suiteTermId = availableTerms[term] || availableTerms[_Terms.MONTHLY] || availableTerms[_Terms.ANNUAL];
      return suiteTermId;
    }

    if (isRecurringMerch) {
      var getEligibleTermIds = getEligibleTermIdsSelector(state);
      var eligibleTermIds = getEligibleTermIds(merchandiseId);
      return (// Attempt to apply desired term, but fallback to whatever is available
        // For cases where the product doesn't support the desired term, like Marketing Ent on monthly terms
        eligibleTermIds[term] || eligibleTermIds[_Terms.MONTHLY] || eligibleTermIds[_Terms.ANNUAL]
      );
    }

    return _TermIds.MONTHLY_NO_DISCOUNT;
  };
};

exports.getTermIdSelector = getTermIdSelector;

var createPurchaseConfigSelector = function createPurchaseConfigSelector(state) {
  return function (_ref) {
    var merchandiseId = _ref.merchandiseId,
        itemConfigurations = _ref.itemConfigurations,
        term = _ref.term,
        termId = _ref.termId,
        _ref$isGrowthSuite = _ref.isGrowthSuite,
        isGrowthSuite = _ref$isGrowthSuite === void 0 ? false : _ref$isGrowthSuite,
        _ref$isCovidPromo = _ref.isCovidPromo,
        isCovidPromo = _ref$isCovidPromo === void 0 ? false : _ref$isCovidPromo;
    var getTermId = getTermIdSelector(state);
    var getDiscountPercentage = getDiscountPercentageSelector(state);
    var currencyCode = (0, _CurrencySelectors.activeCurrencySelector)(state);
    var termIdToUse = termId || getTermId(merchandiseId, term, isGrowthSuite, isCovidPromo);
    var discountPercentage = getDiscountPercentage(merchandiseId, termIdToUse);
    var purchaseConfig = {
      merchandiseId: merchandiseId,
      currencyCode: currencyCode,
      itemConfigurations: itemConfigurations,
      termId: termIdToUse,
      discountPercentage: discountPercentage
    };
    return purchaseConfig;
  };
};

exports.createPurchaseConfigSelector = createPurchaseConfigSelector;

var calculatedPriceSelector = function calculatedPriceSelector(state, _ref2) {
  var merchandiseId = _ref2.merchandiseId,
      termId = _ref2.termId,
      itemConfigurations = _ref2.itemConfigurations,
      _ref2$isGrowthSuite = _ref2.isGrowthSuite,
      isGrowthSuite = _ref2$isGrowthSuite === void 0 ? false : _ref2$isGrowthSuite,
      _ref2$isCovidPromo = _ref2.isCovidPromo,
      isCovidPromo = _ref2$isCovidPromo === void 0 ? false : _ref2$isCovidPromo;
  var merchandise = (0, _MerchandiseSelectors.merchandiseSelector)(state);
  var currentSubscriptions = (0, _CurrentSubscriptionsSelectors.currentSubscriptionsSelector)(state);
  var createPurchaseConfig = createPurchaseConfigSelector(state);

  if (!itemConfigurations.length || !merchandise) {
    return null;
  }

  var purchaseConfig = createPurchaseConfig({
    merchandiseId: merchandiseId,
    itemConfigurations: itemConfigurations,
    termId: termId,
    isGrowthSuite: isGrowthSuite,
    isCovidPromo: isCovidPromo
  });
  return (0, _calculatedPriceAdapter.default)({
    products: merchandise
  }, purchaseConfig, currentSubscriptions);
};

exports.calculatedPriceSelector = calculatedPriceSelector;

var contactTierPriceMapSelector = function contactTierPriceMapSelector(state, merchandiseId, termId) {
  var merchandise = state.merchandise,
      currentSubscriptions = state.currentSubscriptions;
  var currencyCode = (0, _CurrencySelectors.activeCurrencySelector)(state);
  return (0, _contactTierPriceMapAdapter.default)(merchandise, merchandiseId, currencyCode, termId, currentSubscriptions);
};

exports.contactTierPriceMapSelector = contactTierPriceMapSelector;

var getAdditionalContactsMonthlyCostSelector = function getAdditionalContactsMonthlyCostSelector(state) {
  return function (merchandiseId, term) {
    var isGrowthSuite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isCovidPromo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var merchandise = (0, _MerchandiseSelectors.merchandiseSelector)(state);
    var getTermId = getTermIdSelector(state);
    var _merchandise$merchand = merchandise[merchandiseId],
        includedAdditionalUnits = _merchandise$merchand.includedAdditionalUnits,
        additionalUnitMerchId = _merchandise$merchand.additionalUnitMerchId;
    var quantityMultiplier = (0, _ContactsSelectors.contactsQuantityMultiplierSelector)(state, merchandiseId);
    var isInMCBeta = (0, _MarketingContactsSelectors.isInMCBetaSelector)(state);
    var contactsMonthlyCost = calculatedPriceSelector(state, {
      merchandiseId: merchandiseId,
      termId: getTermId(merchandiseId, term),
      itemConfigurations: [(0, _itemConfigUtils.createItemConfigObject)({
        merchandiseId: additionalUnitMerchId,
        quantity: isInMCBeta ? quantityMultiplier // New MC SKUs don't need includedAdditionalUnits in the additional contacts item config
        : includedAdditionalUnits + quantityMultiplier
      })],
      isGrowthSuite: isGrowthSuite,
      isCovidPromo: isCovidPromo
    }).monthly.calculatedPrice;
    return contactsMonthlyCost;
  };
};

exports.getAdditionalContactsMonthlyCostSelector = getAdditionalContactsMonthlyCostSelector;

var getAdditionalContactsCostSelector = function getAdditionalContactsCostSelector(state) {
  return function (contactsMerchandiseId, amount, term) {
    var isGrowthSuite = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var isCovidPromo = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var merchMap = (0, _MerchandiseSelectors.merchandiseSelector)(state);

    var _Object$values$find = Object.values(merchMap).find(function (merch) {
      return merch.additionalUnitMerchId === contactsMerchandiseId;
    }),
        baseMerchId = _Object$values$find.id;

    var termId = getTermIdSelector(state)(baseMerchId, term, isGrowthSuite, isCovidPromo);
    return calculatedPriceSelector(state, {
      merchandiseId: contactsMerchandiseId,
      itemConfigurations: [(0, _itemConfigUtils.createItemConfigObject)({
        merchandiseId: contactsMerchandiseId,
        quantity: amount
      })],
      termId: termId
    });
  };
};

exports.getAdditionalContactsCostSelector = getAdditionalContactsCostSelector;

var getAdditionalSeatMonthlyCostSelector = function getAdditionalSeatMonthlyCostSelector(state) {
  return function (merchandiseId, term) {
    var isGrowthSuite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isCovidPromo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var additionalUnitMerchId = (0, _MerchandiseSelectors.merchandiseSelector)(state)[merchandiseId].additionalUnitMerchId;
    var seatMonthlyCost = calculatedPriceSelector(state, {
      merchandiseId: merchandiseId,
      term: term,
      itemConfigurations: [(0, _itemConfigUtils.createItemConfigObject)({
        merchandiseId: additionalUnitMerchId
      })],
      isGrowthSuite: isGrowthSuite,
      isCovidPromo: isCovidPromo
    }).monthly.calculatedPrice;
    return seatMonthlyCost;
  };
}; // Only used to get the 50% discounted price of Sales and Service Pro Onboarding between 11/1 and EOY 2020
// Context: https://hubspot.slack.com/archives/C824F0ZB5/p1574201654238300?thread_ts=1574201654.238300


exports.getAdditionalSeatMonthlyCostSelector = getAdditionalSeatMonthlyCostSelector;

var getCalculateDiscountedOnboardingPriceSelector = function getCalculateDiscountedOnboardingPriceSelector(state) {
  return function (_ref3) {
    var _ref3$onboardingMerch = _ref3.onboardingMerchId,
        onboardingMerchId = _ref3$onboardingMerch === void 0 ? _MerchandiseIds.SERVICE_SALES_PROFESSIONAL_ONBOARDING_NOV_2019 : _ref3$onboardingMerch,
        _ref3$term = _ref3.term,
        term = _ref3$term === void 0 ? _Terms.MONTHLY : _ref3$term,
        isGrowthSuite = _ref3.isGrowthSuite;
    var getTermId = getTermIdSelector(state);
    var onboardingPrice = calculatedPriceSelector(state, {
      merchandiseId: onboardingMerchId,
      termId: getTermId(onboardingMerchId, term, isGrowthSuite),
      itemConfigurations: [(0, _itemConfigUtils.createItemConfigObject)({
        merchandiseId: onboardingMerchId
      })],
      isGrowthSuite: isGrowthSuite
    });

    var _apply50PercentDiscount = function _apply50PercentDiscount(priceObject) {
      Object.keys(priceObject).forEach(function (termLength) {
        priceObject[termLength].calculatedPrice /= 2;
      });
    };

    _apply50PercentDiscount(onboardingPrice);

    return onboardingPrice;
  };
};

exports.getCalculateDiscountedOnboardingPriceSelector = getCalculateDiscountedOnboardingPriceSelector;

var getCalculatePriceAndItemConfigSelector = function getCalculatePriceAndItemConfigSelector(state) {
  return function (_ref4) {
    var merchandiseId = _ref4.merchandiseId,
        additionalUnitQuantity = _ref4.additionalUnitQuantity,
        _ref4$term = _ref4.term,
        term = _ref4$term === void 0 ? _Terms.MONTHLY : _ref4$term,
        _ref4$isGrowthSuite = _ref4.isGrowthSuite,
        isGrowthSuite = _ref4$isGrowthSuite === void 0 ? false : _ref4$isGrowthSuite,
        _ref4$isCovidPromo = _ref4.isCovidPromo,
        isCovidPromo = _ref4$isCovidPromo === void 0 ? false : _ref4$isCovidPromo;
    var requiredOnboardingMap = (0, _RequiredOnboardingSelectors.requiredOnboardingSelector)(state);
    var getTermId = getTermIdSelector(state);
    var createItemConfigWithMandatoryMerch = (0, _ItemConfigsSelectors.getCreateItemConfigWithMandatoryMerchSelector)(state);
    var calculateDiscountedOnboardingPrice = getCalculateDiscountedOnboardingPriceSelector(state);
    var calculatedPrice = calculatedPriceSelector(state, {
      merchandiseId: merchandiseId,
      termId: getTermId(merchandiseId, term, isGrowthSuite, isCovidPromo),
      itemConfigurations: createItemConfigWithMandatoryMerch(merchandiseId, additionalUnitQuantity),
      isGrowthSuite: isGrowthSuite,
      isCovidPromo: isCovidPromo
    }); // Hacky 11/1 discounted onboarding logic:
    // If user is buying Sales or Service Pro, we avoid appending the onboarding itemConfig
    // so it won't show up in the price.
    // Then we manually calculate its discounted price and add it into the total price of all item

    var shouldIncludeDiscountedServiceProOnboarding = merchandiseId === _MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL && requiredOnboardingMap[_MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL] && requiredOnboardingMap[_MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL].onboardingMerchandiseId === _MerchandiseIds.SERVICE_SERVICE_PROFESSIONAL_ONBOARDING_NOV_2019;

    if (shouldIncludeDiscountedServiceProOnboarding) {
      var discountedOnboardingPrice = calculateDiscountedOnboardingPrice({
        term: term,
        isGrowthSuite: isGrowthSuite,
        onboardingMerchId: _MerchandiseIds.SERVICE_SERVICE_PROFESSIONAL_ONBOARDING_NOV_2019
      });
      return (0, _pricingUtils.mergePriceObjects)([discountedOnboardingPrice, calculatedPrice]);
    }

    var shouldIncludeDiscountedSalesProOnboarding = merchandiseId === _MerchandiseIds.PRODUCT_SALES_PROFESSIONAL_NOV_2019 && requiredOnboardingMap[_MerchandiseIds.PRODUCT_SALES_PROFESSIONAL_NOV_2019] && requiredOnboardingMap[_MerchandiseIds.PRODUCT_SALES_PROFESSIONAL_NOV_2019].onboardingMerchandiseId === _MerchandiseIds.SERVICE_SALES_PROFESSIONAL_ONBOARDING_NOV_2019;

    if (shouldIncludeDiscountedSalesProOnboarding) {
      var _discountedOnboardingPrice = calculateDiscountedOnboardingPrice({
        term: term,
        isGrowthSuite: isGrowthSuite,
        onboardingMerchId: _MerchandiseIds.SERVICE_SALES_PROFESSIONAL_ONBOARDING_NOV_2019
      });

      return (0, _pricingUtils.mergePriceObjects)([_discountedOnboardingPrice, calculatedPrice]);
    }

    return calculatedPrice;
  };
};

exports.getCalculatePriceAndItemConfigSelector = getCalculatePriceAndItemConfigSelector;

var getMultiplePriceBreakdownsSelector = function getMultiplePriceBreakdownsSelector(state) {
  return function (_ref5) {
    var bundleSelections = _ref5.bundleSelections,
        _ref5$term = _ref5.term,
        term = _ref5$term === void 0 ? _Terms.MONTHLY : _ref5$term,
        _ref5$isGrowthSuite = _ref5.isGrowthSuite,
        isGrowthSuite = _ref5$isGrowthSuite === void 0 ? false : _ref5$isGrowthSuite,
        _ref5$isCovidPromo = _ref5.isCovidPromo,
        isCovidPromo = _ref5$isCovidPromo === void 0 ? false : _ref5$isCovidPromo;
    var calculatePriceAndItemConfig = getCalculatePriceAndItemConfigSelector(state);
    var marketingPlanSelected = bundleSelections.marketingPlanSelected,
        salesPlanSelected = bundleSelections.salesPlanSelected,
        servicePlanSelected = bundleSelections.servicePlanSelected,
        cmsPlanSelected = bundleSelections.cmsPlanSelected,
        _bundleSelections$mar = bundleSelections.marketingUnits,
        marketingUnits = _bundleSelections$mar === void 0 ? 0 : _bundleSelections$mar,
        _bundleSelections$sal = bundleSelections.salesUnits,
        salesUnits = _bundleSelections$sal === void 0 ? 0 : _bundleSelections$sal,
        _bundleSelections$ser = bundleSelections.serviceUnits,
        serviceUnits = _bundleSelections$ser === void 0 ? 0 : _bundleSelections$ser,
        _bundleSelections$sel = bundleSelections.selectedAddOns,
        selectedAddOns = _bundleSelections$sel === void 0 ? [] : _bundleSelections$sel,
        _bundleSelections$sel2 = bundleSelections.selectedServices,
        selectedServices = _bundleSelections$sel2 === void 0 ? [] : _bundleSelections$sel2;

    var generatePriceObject = function generatePriceObject(merchandiseId, additionalUnitQuantity) {
      return calculatePriceAndItemConfig({
        merchandiseId: merchandiseId,
        additionalUnitQuantity: additionalUnitQuantity,
        term: term,
        isGrowthSuite: isGrowthSuite,
        isCovidPromo: isCovidPromo
      });
    };

    var priceObjects = [];

    if (salesPlanSelected) {
      priceObjects.push(generatePriceObject(salesPlanSelected, salesUnits));
    }

    if (servicePlanSelected) {
      priceObjects.push(generatePriceObject(servicePlanSelected, serviceUnits));
    }

    if (marketingPlanSelected) {
      priceObjects.push(generatePriceObject(marketingPlanSelected, marketingUnits));
    }

    if (cmsPlanSelected) {
      var isCMSInGrowthSuite = isGrowthSuite && (0, _MerchandiseSelectors.merchandiseEditionSelector)(state, marketingPlanSelected) === (0, _MerchandiseSelectors.merchandiseEditionSelector)(state, cmsPlanSelected); // priceObjects.push(generatePriceObject(cmsPlanSelected));

      priceObjects.push(calculatePriceAndItemConfig({
        merchandiseId: cmsPlanSelected,
        term: term,
        isGrowthSuite: isCMSInGrowthSuite,
        isCovidPromo: false // CMS Hub is excluded from covid promo

      }));
    }

    selectedAddOns.forEach(function (merchandiseId) {
      // priceObjects.push(generatePriceObject(merchandiseId));
      priceObjects.push(calculatePriceAndItemConfig({
        merchandiseId: merchandiseId,
        term: term,
        isGrowthSuite: isGrowthSuite,
        isCovidPromo: false // Addons are excluded from covid promo

      }));
    });
    selectedServices.forEach(function (merchandiseId) {
      priceObjects.push(calculatePriceAndItemConfig({
        merchandiseId: merchandiseId,
        term: term,
        isGrowthSuite: false // services are never available for suite discount

      }));
    });
    return priceObjects;
  };
};

exports.getMultiplePriceBreakdownsSelector = getMultiplePriceBreakdownsSelector;

var getCalculateBundlePriceSelector = function getCalculateBundlePriceSelector(state) {
  return function (_ref6) {
    var bundleSelections = _ref6.bundleSelections,
        _ref6$term = _ref6.term,
        term = _ref6$term === void 0 ? _Terms.MONTHLY : _ref6$term,
        _ref6$isGrowthSuite = _ref6.isGrowthSuite,
        isGrowthSuite = _ref6$isGrowthSuite === void 0 ? false : _ref6$isGrowthSuite,
        _ref6$isCovidPromo = _ref6.isCovidPromo,
        isCovidPromo = _ref6$isCovidPromo === void 0 ? false : _ref6$isCovidPromo;
    var getMultiplePriceBreakdowns = getMultiplePriceBreakdownsSelector(state);
    var priceObjects = getMultiplePriceBreakdowns({
      bundleSelections: bundleSelections,
      term: term,
      isGrowthSuite: isGrowthSuite,
      isCovidPromo: isCovidPromo
    });
    var totalPrice = (0, _pricingUtils.mergePriceObjects)(priceObjects);
    return totalPrice;
  };
};

exports.getCalculateBundlePriceSelector = getCalculateBundlePriceSelector;

var areIncludedUnitsInBaseMerchSelector = function areIncludedUnitsInBaseMerchSelector(state, baseMerchandiseId) {
  var merchMap = (0, _MerchandiseSelectors.merchandiseSelector)(state);
  var additionalUnitMerchId = merchMap[baseMerchandiseId].additionalUnitMerchId;
  var units = merchMap[additionalUnitMerchId].units; // This might change in the future, but for now this is the
  // recommended way to proxy the new pricing structure

  return units === 'marketing contact';
};

exports.areIncludedUnitsInBaseMerchSelector = areIncludedUnitsInBaseMerchSelector;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/PricingSelectors.js
// module id = 31
// module chunks = 5 6 7